import { Divider, useMediaQuery } from "@mui/material";
import React from "react";
import theme from "../../../theme";

type Props = {
  rightPosition: string;
  height?: string;
  zIndex?: number;};

const DividerCustom = (props: Props) => {
  const { rightPosition, height , zIndex} = props;
  const isSmScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Divider
      orientation="vertical"
      flexItem
      sx={{
        position: "absolute",
        height: height || "900vh",
        width: isSmScreen ? "0.05px" : "0.4px",
        right: rightPosition,
        zIndex: 1,
        backgroundColor: "rgba(0, 0, 0, 0.313)",
        opacity: isSmScreen ? "0.13" : "0.2",
      }}
    />
  );
};

export default DividerCustom;
